'use client';
import { AtText } from '@/components/atoms';
import { EClickableVariants } from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { OrMiniCtaBlockA } from '@/components/organisms';
import { useLocation } from '@/context/locationContext';
import { LoginModalContext } from '@/context/loginModalContext';
import { EThemes } from '@/lib/contentstack-sdk/types';
import { useState, useEffect, useContext } from 'react';
import { useHomePlanData } from './hooks/useHomePlanData';

export const TmHomePlanDetailThreeDBanner = ({
  hasThreeD,
  planId,
}: {
  hasThreeD: boolean;
  planId: number;
}) => {
  const [has3D, setHas3D] = useState<boolean>(false);
  const [is3DLoading, setIs3DLoading] = useState<boolean>(false);
  const [loginUrl, setLoginUrl] = useState<string>('');
  const { currentBuildStudio } = useLocation();

  const {
    setElevationIdForLogin,
    setPlanIdForLogin,
    setStudioIdForLogin,
    buildLoginUrl,
  } = useContext(LoginModalContext);

  const { selectedExterior, baseElevation } = useHomePlanData(planId);

  useEffect(() => {
    const fetch3dData = async () => {
      setIs3DLoading(true);
      setHas3D(!!currentBuildStudio?.supports3D && hasThreeD);
      setIs3DLoading(false);
    };

    fetch3dData();
  }, [currentBuildStudio?.Id, currentBuildStudio?.supports3D, hasThreeD]);
  useEffect(() => {
    if (is3DLoading) return;

    const url = buildLoginUrl({
      StudioId: currentBuildStudio
        ? currentBuildStudio.Id?.toString()
        : undefined,
      ElevationId: String(selectedExterior?.id) || String(baseElevation?.Id),
      PlanId: `${planId}`,
      LoginAction: has3D ? 'CUSTOMIZE_PLAN_3D' : 'CUSTOMIZE_PLAN',
    });

    setLoginUrl(url);
  }, [
    is3DLoading,
    buildLoginUrl,
    currentBuildStudio,
    selectedExterior?.id,
    baseElevation?.Id,
    planId,
    has3D,
  ]);

  return (
    <>
      {has3D && (
        <OrMiniCtaBlockA
          topSpacing="xl"
          bottomSpacing="xl"
          theme={EThemes.LIGHT}
          icon={EIcons.THREED}
          cta={{
            variant: EClickableVariants.PRIMARY,
            label: has3D ? 'Customize in 3D' : 'Customize & Price',
            href: loginUrl,
            interactLocation: 'tm-home-plan-detail',
          }}
        >
          <AtText size="lg" className="!leading-[2.5rem]">
            <strong>Refine this home with our 3D Visualizer: </strong>
            modify your floor plan, exterior, and interior design
          </AtText>
        </OrMiniCtaBlockA>
      )}
    </>
  );
};
